import React, { FC, VideoHTMLAttributes, useEffect, useRef, useState } from "react";
import PlaceIcon from "./PlaceIcon";

export interface NcVideoProps extends VideoHTMLAttributes<HTMLVideoElement> {
  containerClassName?: string;
  userImage?: string;  // Imagen de usuario
}

const StoryVideo: FC<NcVideoProps> = ({
  containerClassName = "",
  src = "",
  className = "object-cover w-full h-full",
  userImage = "",
  ...args
}) => {
  const _containerRef = useRef(null);
  const [__src, set__src] = useState("");
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    if (src && _containerRef.current) {
      set__src(src);
      setVideoLoaded(true);
    }
  }, [src]); 

  const renderLoadingPlaceholder = () => (
    <div
      className={`${className} flex items-center justify-center bg-neutral-200 dark:bg-neutral-6000 text-neutral-100 dark:text-neutral-500`}
    >
      <div className="h-2/4 max-w-[50%]">
        <PlaceIcon />
      </div>
    </div>
  );

  return (
    <div
      className={`nc-NcVideo ${containerClassName}`}
      data-nc-id="NcVideo"
      ref={_containerRef}
    //   style={{ position: "relative" }}
    >
      {__src && videoLoaded ? (
        <video className={className} muted loop>
          <source src={__src} type="video/mp4" />
        </video>
      ) : (
        renderLoadingPlaceholder()
      )}

      {/* Imagen de usuario en la esquina superior derecha */}
      {userImage && (
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            overflow: "hidden",
            border: "2px solid white",
          }}
        >
          <img
            src={userImage}
            alt="User"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default StoryVideo;
